import { IpadLogsModel } from '@w3lcome/types';

import RequestCreator from './BaseRequest';

const api = new RequestCreator<IpadLogsModel>('/ipad/ipad-logs');
export default api;
